import clsx from 'clsx'
import React, { memo, useMemo } from 'react'
import { OutcomeContent } from '../../../dto'
import styles from './index.module.scss'

export const ShapeTitle = memo(({ data }: { data: OutcomeContent }) => {
  const titleHtmlAtr = useMemo(() => ({ __html: data?.title || '' }), [data?.title])
  return <div className={clsx(styles.defaultFont, 'fullWidth')} dangerouslySetInnerHTML={titleHtmlAtr} />
})
